import React, { ElementType, ReactNode } from 'react';
import ExclamationSmall from '../../icons/ExclamationSmall';
import { ColorKeys } from '../../theme/colors';
import Stack from '../Stack/Stack';
import Text from '../Text/Text';

export type FormControlProps = {
  title?: ReactNode;
  children: ReactNode;
  error?: string | boolean;
  warning?: string | boolean;
  helperText?: ReactNode;
  optional?: boolean | string;
  disabled?: boolean;
  as?: ElementType;
};

const FormControl = ({
  children,
  title,
  disabled,
  error,
  warning,
  helperText,
  optional,
  as = 'label',
}: FormControlProps) => {
  let textColor = 'gray-600' as ColorKeys;
  if (disabled) {
    textColor = 'gray-300';
  } else if (error) {
    textColor = 'cherry';
  } else if (warning) {
    textColor = 'peach-dark';
  }
  return (
    <Stack as={as} space={1}>
      {title && (
        <Text variant="subtitle2" textColor={textColor}>
          {title}
          {optional && (
            <Text as="span" variant="body2" ml={1} muted>
              {typeof optional === 'string' ? optional : 'Optional'}
            </Text>
          )}
        </Text>
      )}
      {children}
      {helperText && !error && !warning && (
        <Text variant="body2" muted>
          {helperText}
        </Text>
      )}
      {warning && typeof warning === 'string' && warning.trim() !== '' && (
        <Stack
          row
          space={0.5}
          fontSize="base"
          alignItems="flex-start"
          textColor="peach-dark"
        >
          <ExclamationSmall size="sm" color="peach-dark" />
          <Text variant="body2" textColor="peach-dark">
            {warning}
          </Text>
        </Stack>
      )}
      {error && typeof error === 'string' && error.trim() !== '' && (
        <Stack
          row
          space={0.5}
          fontSize="base"
          alignItems="flex-start"
          textColor="cherry"
        >
          <ExclamationSmall size="sm" textColor="cherry" />
          <Text variant="body2" textColor="cherry">
            {error}
          </Text>
        </Stack>
      )}
    </Stack>
  );
};

FormControl.displayName = 'FormControl';
export default FormControl;
